export const insuranceMenuDef = [
    {
        name: 'Beneficiary Validations',
        resource: 'insurance_beneficiary_format',
        icon: 'fa fa-plus-square',
        url: 'insurance_beneficiary_format',
        auto_crud: true,
        breadcrumb: 'Beneficiary Validations',
        showMenu: true
    },
    {
        name: 'TPA Old',
        resource: 'preAuthorization_requests',
        icon: 'fa fa-plus-square',
        url: 'preAuthorization_requests',
        auto_crud: true,
        breadcrumb: 'TPA Old',
        showMenu: true
    },
    {
        name: 'HI AUTH',
        resource: 'hi_insurance',
        icon: 'fa fa-plus-square',
        url: 'hi_insurance',
        auto_crud: true,
        breadcrumb: 'HI AUTH',
        showMenu: true
    },
    {
        name: 'Bene Old',
        resource: 'beneficiary_validation',
        icon: 'fa fa-plus-square',
        url: 'beneficiary_validation',
        auto_crud: true,
        breadcrumb: 'Bene Old',
        showMenu: true
    },
    {
        name: 'menu.patient_submitted_bill',
        resource: "patient_submitted_bill",
        icon: 'fa fa-h-square',
        url: 'patient_submitted_bill',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'TPA Approvals',
        resource: 'insurance_format',
        icon: 'fa fa-plus-square',
        url: 'insurance_format',
        auto_crud: true,
        breadcrumb: 'TPA Approvals',
        showMenu: true
    },
    {
        name: 'TPA Discharge Approvals',
        resource: 'ins_discharge_format',
        icon: 'fa fa-plus-square',
        url: 'ins_discharge_format',
        auto_crud: true,
        breadcrumb: 'TPA Approvals',
        showMenu: true
    },
    {
        name: 'Manual Approvals',
        resource: 'insurance_manual_approvals',
        icon: 'fa fa-plus-square',
        url: 'insurance_manual_approvals',
        auto_crud: true,
        breadcrumb: 'Manual Approvals',
        showMenu: true
    },
    {
        name: 'TPA Approvals',
        resource: 'insurance_event_format',
        icon: 'fa fa-plus-square',
        url: 'insurance_event_format',
        auto_crud: true,
        breadcrumb: 'TPA Approvals',
        showMenu: true
    },
    {
        name: 'Need More Information',
        resource: 'nmi_format',
        icon: 'fa fa-plus-square',
        url: 'nmi_format',
        auto_crud: true,
        breadcrumb: 'Need More Information',
        showMenu: true
    },
    {
        name: 'Pre Authorization NMI Query',
        resource: 'preAuthorization_nmi_query',
        icon: 'fa fa-plus-square',
        url: 'preAuthorization_nmi_query',
        auto_crud: true,
        breadcrumb: 'Pre Authorization NMI Query',
        showMenu: true
    },
    {
        name: 'Interm Enhance',
        resource: 'interm_enhance',
        icon: 'fa fa-plus-square',
        url: 'interm_enhance',
        auto_crud: true,
        breadcrumb: 'Interm Enhance',
        showMenu: true
    },
    {
        name: 'Interm Enhance NMI',
        resource: 'interm_enhance_nmi_query',
        icon: 'fa fa-plus-square',
        url: 'interm_enhance_nmi_query',
        auto_crud: true,
        breadcrumb: 'Interm Enhance NMI',
        showMenu: true
    },
    {
        name: 'Insurance Event History Details',
        resource: 'insurance_event_history_details',
        icon: 'fa fa-plus-square',
        url: 'insurance_event_history_details',
        auto_crud: true,
        breadcrumb: 'Insurance Event History Details',
        showMenu: false
    },
    {
        name: 'Enhance Discharge Submission',
        resource: 'enhance_discharge_submission',
        icon: 'fa fa-plus-square',
        url: 'enhance_discharge_submission',
        auto_crud: true,
        breadcrumb: 'Enhance Discharge Submission',
        showMenu: true
    },
    {
        name: 'Enhance Discharge NMI',
        resource: 'discharge_nmi_query',
        icon: 'fa fa-plus-square',
        url: 'discharge_nmi_query',
        auto_crud: true,
        breadcrumb: 'Enhance Discharge NMI',
        showMenu: true
    },
    {
        name: 'Claims',
        resource: 'claims_format',
        icon: 'fa fa-plus-square',
        url: 'claims_format',
        auto_crud: true,
        breadcrumb: 'Claims',
        showMenu: true
    },
    {
        name: 'Payments',
        resource: 'payment_format',
        icon: 'fa fa-plus-square',
        url: 'payment_format',
        auto_crud: true,
        breadcrumb: 'Payments',
        showMenu: true
    },
    {
        name: 'Claim Old',
        resource: 'claim_submission',
        icon: 'fa fa-plus-square',
        url: 'claim_submission',
        auto_crud: true,
        breadcrumb: 'Claim Submission',
        showMenu: true
    },
    {
        name: 'Claim Submission NMI',
        resource: 'claim_nmi_query',
        icon: 'fa fa-plus-square',
        url: 'claim_nmi_query',
        auto_crud: true,
        breadcrumb: 'Claim Submission NMI',
        showMenu: true
    },
    {
        name: 'Claim Status',
        resource: 'claim_status',
        icon: 'fa fa-plus-square',
        url: 'claim_status',
        auto_crud: true,
        breadcrumb: 'Claim Status',
        showMenu: true
    },
    {
        name: 'Payer List',
        resource: 'insurance_payer',
        icon: 'fa fa-plus-square',
        url: 'insurance_payer',
        auto_crud: true,
        breadcrumb: 'Insurance Payer',
        showMenu: true
    },
    {
        name: 'Ailment List',
        resource: 'insurance_ailment',
        icon: 'fa fa-plus-square',
        url: 'insurance_ailment',
        auto_crud: true,
        breadcrumb: 'Insurance Ailment',
        showMenu: true
    },
    {
        name: 'Company List',
        resource: 'insurance_company',
        icon: 'fa fa-plus-square',
        url: 'insurance_company',
        auto_crud: true,
        breadcrumb: 'Company List',
        showMenu: true
    },
    {
        name: 'Provisional Diagnosis',
        resource: 'insurance_provisional_diagnosis',
        icon: 'fa fa-plus-square',
        url: 'insurance_provisional_diagnosis',
        auto_crud: true,
        breadcrumb: 'Provisional Diagnosis',
        showMenu: true
    },
    {
        name: 'Provisional Treatment',
        resource: 'insurance_provisional_treatment',
        icon: 'fa fa-plus-square',
        url: 'insurance_provisional_treatment',
        auto_crud: true,
        breadcrumb: 'Provisional Treatment',
        showMenu: true
    },
    {
        name: 'Cooporate',
        resource: 'insurance_cooporate',
        icon: 'fa fa-plus-square',
        url: 'insurance_cooporate',
        auto_crud: true,
        breadcrumb: 'Insurance Cooporate',
        showMenu: true
    },
    {
        name: 'Zones',
        resource: 'insurance_zone',
        icon: 'fa fa-plus-square',
        url: 'insurance_zone',
        auto_crud: true,
        breadcrumb: 'Insurance Zone',
        showMenu: true
    },
    {
        name: 'Rooms',
        resource: 'insurance_room',
        icon: 'fa fa-plus-square',
        url: 'insurance_room',
        auto_crud: true,
        breadcrumb: 'Insurance Room',
        showMenu: true
    },
    {
        name: 'Insurance Mapper',
        resource: 'insurance_mapper',
        icon: 'fa fa-plus-square',
        url: 'insurance_mapper',
        auto_crud: true,
        breadcrumb: 'Insurance Mapper',
        showMenu: true
    },
    {
        "name": "menu.miscellaneous",
        "resource": "billing_item_miscllaneous",
        "icon": "fa fa-user",
        "url": "billing_item_miscllaneous",
        "auto_crud": true,
        "breadcrumb": "Miscellaneous",
        "showMenu": false
    },
    {
        "name": "menu.miscellaneous",
        "resource": "insurance_billing_miscllaneous",
        "icon": "fa fa-user",
        "url": "insurance_billing_miscllaneous",
        "auto_crud": true,
        "breadcrumb": "Miscellaneous",
        "showMenu": false
    },
    {
        "name": "menu.miscellaneous",
        "resource": "insurance_billing_item_miscllaneous",
        "icon": "fa fa-user",
        "url": "insurance_billing_item_miscllaneous",
        "auto_crud": true,
        "breadcrumb": "Miscellaneous",
        "showMenu": false
    },
    {
        "name": "menu.biiling_main",
        "resource": "billing_upload",
        "icon": "fa fa-user",
        "url": "billing_upload",
        "auto_crud": true,
        "breadcrumb": "insurance",
        "showMenu": false,
        "check_permission": false
    },
    {
        name: 'Event History',
        resource: 'insurance_event_history',
        icon: 'fa fa-plus-square',
        url: 'insurance_event_history',
        auto_crud: true,
        breadcrumb: 'Insurance History',
        showMenu: true
    },
    {
        name: 'menu.referral_request_process',
        resource: 'referral_request_format',
        icon: 'fa fa-plus-square',
        url: 'referral_request_format',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        "name": "m.referral_request_approval",
        "resource": "referral_request_approval",
        "icon": "fa fa-user-md",
        "url": "referral_request_approval",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Approved Referral Request"
    },
    {
        "name": "m.referral_request_approval_pre_authorization",
        "resource": "referral_request_approval",
        "icon": "fa fa-user-md",
        "url": "referral_request_approval_pre_authorization",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Pre-Authorization"
    },
    {
        "name": "m.referral_request_approval_enhanced",
        "resource": "referral_request_approval",
        "icon": "fa fa-user-md",
        "url": "referral_request_approval_enhanced",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Pre-Authorization"
    },
    {
        "name": "m.hie_eligibility_history_tab",
        "resource": "hie_eligibility_history_tab",
        "icon": "fa fa-user-md",
        "url": "hie_eligibility_history_tab",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Hie Eligibility"
    },
    {
        "name": "m.preauthorization_requests_items",
        "resource": "preauthorization_requests_items",
        "icon": "fa fa-user-md",
        "url": "preauthorization_requests_items",
        "check_permission": false,
        "auto_crud": "View Items"
    },
    {
        "name": "m.referral_request_approval_answered",
        "resource": "referral_request_approval",
        "icon": "fa fa-user-md",
        "url": "referral_request_approval_answered",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Answered"
    },
    {
        "name": "m.referral_request_approval_denied",
        "resource": "referral_request_approval",
        "icon": "fa fa-user-md",
        "url": "referral_request_approval_denied",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Denied"
    },
    {
        "name": "m.referral_request_approval_approved",
        "resource": "referral_request_approval",
        "icon": "fa fa-user-md",
        "url": "referral_request_approval_approved",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Approved"
    },
    {
        "name": "m.submitted_bill",
        "resource": "view_bill_details",
        "icon": "fa fa-user-md",
        "url": "submitted_bill",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Bill Submitted"
    },
    {
        "name": "m.acknowledged_bill",
        "resource": "view_bill_details",
        "icon": "fa fa-user-md",
        "url": "acknowledged_bill",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Bill Acknowledged"
    },
    {
        "name": "m.acknowledged_bill",
        "resource": "view_bill_details",
        "icon": "fa fa-user-md",
        "url": "level_two_deduction",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Bill Acknowledged"
    },
    {
        "name": "m.submitted_bill_queries",
        "resource": "view_query_bill_history",
        "icon": "fa fa-user-md",
        "url": "view_query_bill_history",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Bill Submitted"
    },
    {
        "name": "m.submitted_bill_queries",
        "resource": "submitted_bill_queries",
        "icon": "fa fa-user-md",
        "url": "submitted_bill_queries",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Queries"
    },
    {
        "name": "m.submitted_bill_answered",
        "resource": "view_bill_details",
        "icon": "fa fa-user-md",
        "url": "submitted_bill_answered",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Answered"
    },
    {
        "name": "m.submitted_bill_approved",
        "resource": "view_bill_details",
        "icon": "fa fa-user-md",
        "url": "submitted_bill_approved",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Approved"
    },
    {
        "name": "m.submtted_paid",
        "resource": "submtted_paid",
        "icon": "fa fa-user-md",
        "url": "submtted_paid",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "paid"
    },
    {
        "name": "m.referral_request_approval_queries",
        "resource": "referral_request_approval",
        "icon": "fa fa-user-md",
        "url": "referral_request_approval_queries",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Queries"
    },
    {
        name: 'menu.submitted_bill',
        resource: 'approved_claim_format',
        icon: 'fa fa-plus-square',
        url: 'approved_claim_format',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.submitted_bill',
        resource: 'insurance_billing',
        icon: 'fa fa-plus-square',
        url: 'insurance_billing',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.submitted_bill',
        resource: 'queries_insurance_billing',
        icon: 'fa fa-plus-square',
        url: 'queries_insurance_billing',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.referral_request_approval_queries_form',
        resource: 'referral_request_approval_queries_form',
        icon: 'fa fa-plus-square',
        url: 'referral_request_approval_queries_form',
        check_permission: false,
        auto_crud: true,
        showMenu: true,
    },
    {
        name: 'menu.submitted_bill',
        resource: 'insurance_billing_denied',
        icon: 'fa fa-plus-square',
        url: 'insurance_billing_denied',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.submitted_bill',
        resource: 'referral_request_approval_denied_form',
        icon: 'fa fa-plus-square',
        url: 'referral_request_approval_denied_form',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.submitted_bill',
        resource: 'insurance_billing_preauth',
        icon: 'fa fa-plus-square',
        url: 'insurance_billing_preauth',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.referral_request_history',
        resource: 'referral_request_history',
        icon: 'fa fa-plus-square',
        url: 'referral_request_history',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.submitted_bill',
        resource: 'insurance_billing_answered',
        icon: 'fa fa-plus-square',
        url: 'insurance_billing_answered',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.referral_request_approval_approve_form',
        resource: 'referral_request_approval_approve_form',
        icon: 'fa fa-plus-square',
        url: 'referral_request_approval_approve_form',
        check_permission: false,
        auto_crud: true,
        showMenu: true,
    },
    {
        name: 'menu.pre_authorization_request_approved',
        resource: 'pre_authorization_request_approved',
        icon: 'fa fa-plus-square',
        url: 'pre_authorization_request_approved',
        check_permission: false,
        auto_crud: true,
        showMenu: true,
    },
    {
        name: 'menu.authorization_request_approved',
        resource: 'authorization_request_approved',
        icon: 'fa fa-plus-square',
        url: 'authorization_request_approved',
        check_permission: false,
        auto_crud: true,
        showMenu: true,
    },
    {
        name: 'menu.submitted_bill',
        resource: 'split_view',
        icon: 'fa fa-plus-square',
        url: 'split_view',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.submitted_bill',
        resource: 'insurance_billing_approved',
        icon: 'fa fa-plus-square',
        url: 'insurance_billing_approved',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.submitted_bill',
        resource: 'insurance_billing_accept',
        icon: 'fa fa-plus-square',
        url: 'insurance_billing_accept',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.referral_request_approval_answer_form',
        resource: 'referral_request_approval_answer_form',
        icon: 'fa fa-plus-square',
        url: 'referral_request_approval_answer_form',
        check_permission: false,
        auto_crud: true,
        showMenu: true,
    },
    {
        name: 'menu.submitted_bill',
        resource: 'insurance_billing_reject',
        icon: 'fa fa-plus-square',
        url: 'insurance_billing_reject',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.submitted_bill',
        resource: 'insurance_billing_paid',
        icon: 'fa fa-plus-square',
        url: 'insurance_billing_paid',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.submitted_bill',
        resource: 'insurance_billing_enhanced',
        icon: 'fa fa-plus-square',
        url: 'insurance_billing_enhanced',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.submitted_bill',
        resource: 'bill_history_view',
        icon: 'fa fa-plus-square',
        url: 'bill_history_view',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.submitted_bill',
        resource: 'bill_view',
        icon: 'fa fa-plus-square',
        url: 'bill_view',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        "name": "menu.referral_request_approval",
        "resource": "split_view",
        "icon": "fa fa-user",
        "url": "split_view",
        "auto_crud": true,
        "breadcrumb": "Discharged Patients",
        "showMenu": false
    },
    {
        name: 'menu.pharmacy_authorization',
        resource: 'pharmacy_authorization',
        icon: 'fa fa-plus-square',
        url: 'pharmacy_authorization',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.op_authorization',
        resource: 'op_authorization',
        icon: 'fa fa-plus-square',
        url: 'op_authorization',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.hie_authorization_requests_items',
        resource: 'hie_authorization_requests_items',
        icon: 'fa fa-plus-square',
        url: 'hie_authorization_requests_items',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.hie_claim_requests_items',
        resource: 'hie_claim_requests_items',
        icon: 'fa fa-plus-square',
        url: 'hie_claim_requests_items',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.hie_eligibility_details',
        resource: 'hie_eligibility_history_tab',
        icon: 'fa fa-plus-square',
        url: 'hie_eligibility_history_tab',
        auto_crud: true,
        breadcrumb: 'HIE Eligibility',
        showMenu: true
    },
    {
        name: 'menu.hie_eligibility_details',
        resource: 'hie_eligibility_format',
        icon: 'fa fa-plus-square',
        url: 'hie_eligibility_format',
        auto_crud: true,
        breadcrumb: 'HIE Eligibility',
        showMenu: true
    },
    {
        resource: "eligibility_request",
        url: "eligibility_request",
        auto_crud: true
    },
    {
        name: 'menu.hie_authorization',
        resource: 'hie_authorization_format',
        icon: 'fa fa-plus-square',
        url: 'hie_authorization_format',
        auto_crud: true,
        breadcrumb: 'HIE Authorization',
        showMenu: true
    },
    {
        name: 'menu.op_authorization_view',
        resource: 'op_authorization_view',
        icon: 'fa fa-plus-square',
        url: 'op_authorization_view',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.retry_op_authorization',
        resource: 'retry_op_authorization',
        icon: 'fa fa-plus-square',
        url: 'retry_op_authorization',
        check_permission: false,
        auto_crud: true,
        breadcrumb: 'HIE Authorization',
        showMenu: true
    },
    {
        name: 'menu.admission_auth_request',
        resource: 'admission_auth_request',
        icon: 'fa fa-plus-square',
        url: 'admission_auth_request',
        check_permission: false,
        auto_crud: true,
        breadcrumb: 'HIE Authorization',
        showMenu: true
    },
    {
        name: 'menu.direct_authorization',
        resource: 'direct_authorization',
        icon: 'fa fa-plus-square',
        url: 'direct_authorization',
        check_permission: false,
        auto_crud: true,
        breadcrumb: 'HIE Authorization',
        showMenu: true
    },
    {
        name: 'menu.eligible_auth',
        resource: 'eligibile_auth',
        icon: 'fa fa-plus-square',
        url: 'eligibile_auth',
        check_permission: false,
        auto_crud: true,
        breadcrumb: 'HIE Authorization',
        showMenu: true
    },
    {
        name: 'menu.nhx_eligibility_form',
        resource: 'nhx_eligibility_form',
        icon: 'fa fa-plus-square',
        url: 'nhx_eligibility_form',
        check_permission: false,
        auto_crud: true,
        breadcrumb: 'HIE Eligibility',
        showMenu: true
    },
    {
        name: 'menu.eligibility_form',
        resource: 'eligibility_form',
        icon: 'fa fa-plus-square',
        url: 'eligibility_form',
        check_permission: false,
        auto_crud: true,
        breadcrumb: 'HIE Eligibility',
        showMenu: true
    },
    {
        name: 'menu.hie_claim_request',
        resource: 'hie_claim_request',
        icon: 'fa fa-plus-square',
        url: 'hie_claim_request',
        check_permission: false,
        auto_crud: true,
        breadcrumb: 'HIE Claim',
        showMenu: true
    },
    {
        name: 'menu.hie_e_order_claim_request',
        resource: 'hie_e_order_claim_request',
        icon: 'fa fa-plus-square',
        url: 'hie_e_order_claim_request',
        check_permission: false,
        auto_crud: true,
        breadcrumb: 'HIE Claim',
        showMenu: true
    },
    {
        name: 'menu.relate_hie_claim_request',
        resource: 'relate_hie_claim_request',
        icon: 'fa fa-plus-square',
        url: 'relate_hie_claim_request',
        check_permission: false,
        auto_crud: true,
        breadcrumb: 'HIE Claim',
        showMenu: true
    },
    {
        name: 'menu.relate_hie_e_order_claim_request',
        resource: 'relate_hie_e_order_claim_request',
        icon: 'fa fa-plus-square',
        url: 'relate_hie_e_order_claim_request',
        check_permission: false,
        auto_crud: true,
        breadcrumb: 'HIE Claim',
        showMenu: true
    },
    {
        name: 'menu.insurance_level_one',
        resource: 'insurance_level_one',
        icon: 'fa fa-plus-square',
        url: 'insurance_level_one',
        check_permission: false,
        auto_crud: true,
        breadcrumb: 'HIE Authorization',
        showMenu: true
    },
    {
        name: 'menu.insurance_level_two',
        resource: 'insurance_level_two',
        icon: 'fa fa-plus-square',
        url: 'insurance_level_two',
        check_permission: false,
        auto_crud: true,
        breadcrumb: 'HIE Authorization',
        showMenu: true
    },
    {
        name: 'menu.hie_claim',
        resource: 'hie_claim_format',
        icon: 'fa fa-plus-square',
        url: 'hie_claim_format',
        auto_crud: true,
        breadcrumb: 'HIE Claim',
        showMenu: true
    },
    {
        name: 'menu.submitted_bill',
        resource: 'view_referral_request_form',
        icon: 'fa fa-plus-square',
        url: 'view_referral_request_form',
        auto_crud: true,
        breadcrumb: 'HIE Claim',
        showMenu: true
    },
    {
        name: 'menu.billing_auth_request',
        resource: 'billing_auth_request',
        icon: 'fa fa-plus-square',
        url: 'billing_auth_request',
        auto_crud: true,
        breadcrumb: 'HIE Authorization',
        showMenu: true,
        check_permission: false,
    },
    {
        name: 'menu.submitted_bill',
        resource: 'insurance_billing_enanced',
        icon: 'fa fa-plus-square',
        url: 'insurance_billing_enanced',
        auto_crud: true,
        breadcrumb: 'HIE Claim',
        showMenu: true
    },
    {
        name: 'menu.admission_preauth_request',
        resource: 'admission_preauth_request',
        icon: 'fa fa-plus-square',
        url: 'admission_preauth_request',
        auto_crud: true,
        showMenu: true,
        breadcrumb: 'HIE Nhcx Authorization',
        check_permission: false,
    },
    {
        name: 'menu.hie_e_order',
        resource: 'hie_e_order_format',
        icon: 'fa fa-plus-square',
        url: 'hie_e_order_format',
        auto_crud: true,
        breadcrumb: 'HIE E-Order',
        showMenu: true
    },
    {
        name: 'menu.hie_e_order',
        resource: 'hie_e_order',
        icon: 'fa fa-plus-square',
        url: 'hie_e_order',
        auto_crud: true,
        breadcrumb: 'HIE E-Order',
        showMenu: true
    },
    {
        name: 'menu.hie_e_order_download',
        resource: 'hie_e_order_download',
        icon: 'fa fa-plus-square',
        url: 'hie_e_order_download',
        auto_crud: true,
        breadcrumb: 'HIE E-Order',
        showMenu: true
    },
    {
        name: 'menu.answer_insurance_form',
        resource: 'answer_insurance_form',
        icon: 'fa fa-plus-square',
        url: 'answer_insurance_form',
        auto_crud: true,
        breadcrumb: 'HIE E-Order',
        showMenu: true
    },
    {
        name: 'menu.medication_dispense_order',
        resource: 'medication_dispense_order',
        icon: 'fa fa-plus-square',
        url: 'medication_dispense_order',
        auto_crud: true,
        breadcrumb: 'HIE E-Order',
        showMenu: true
    },
    {
        name: 'menu.service_item_dispense_order',
        resource: 'service_item_dispense_order',
        icon: 'fa fa-plus-square',
        url: 'service_item_dispense_order',
        auto_crud: true,
        breadcrumb: 'HIE E-Order',
        showMenu: true
    },
    {
        name: 'menu.mark_compliance',
        resource: 'mark_compliance',
        icon: 'fa fa-plus-square',
        url: 'mark_compliance',
        auto_crud: true,
        breadcrumb: 'Mark Compliance',
        showMenu: true
    },
    {
        name: 'menu.view_authorization_request',
        resource: 'view_authorization_request',
        icon: 'fa fa-plus-square',
        url: 'view_authorization_request',
        auto_crud: true,
        breadcrumb: 'View Authorization Request',
        showMenu: true
    },
    {
        name: 'menu.e_order_authorization',
        resource: 'e_order_authorization',
        icon: 'fa fa-plus-square',
        url: 'e_order_authorization',
        auto_crud: true,
        breadcrumb: 'View E-Order Authorization Request',
        showMenu: true
    },
    {
        name: 'menu.view_e_order_authorization_request',
        resource: 'view_e_order_authorization_request',
        icon: 'fa fa-plus-square',
        url: 'view_e_order_authorization_request',
        auto_crud: true,
        breadcrumb: 'View E-Order Authorization Request',
        showMenu: true
    },
    {
        name: 'menu.nhcx_eligibility_request_tab',
        resource: 'nhcx_eligibility_request_tab',
        icon: 'fa fa-plus-square',
        url: 'nhcx_eligibility_request_tab',
        auto_crud: true,
        breadcrumb: 'NHCX Eligibility Request Tab',
        showMenu: true
    },
    {
        name: 'menu.ihx_tab',
        resource: 'ihx_tab',
        icon: 'fa fa-plus-square',
        url: 'ihx_tab',
        auto_crud: true,
        breadcrumb: 'NHCX Eligibility Request Tab',
        showMenu: true
    },
    {
        name: 'menu.ihx_authorization_history',
        resource: 'ihx_authorization_history',
        icon: 'fa fa-plus-square',
        url: 'ihx_authorization_history',
        auto_crud: true,
        breadcrumb: 'NHCX Eligibility Request Tab',
        showMenu: true
    },
    {
        name: 'menu.ihx_claim_history',
        resource: 'ihx_claim_history',
        icon: 'fa fa-plus-square',
        url: 'ihx_claim_history',
        auto_crud: true,
        breadcrumb: 'NHCX Eligibility Request Tab',
        showMenu: true
    },
    {
        name: 'menu.ihx_claim_letters',
        resource: 'ihx_claim_letters',
        icon: 'fa fa-plus-square',
        url: 'ihx_claim_letters',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.nhcx_communication_request',
        resource: 'nhcx_communication_request',
        icon: 'fa fa-plus-square',
        url: 'nhcx_communication_request',
        auto_crud: true,
        breadcrumb: 'NHCX Communication request',
        showMenu: true
    },
    {
        name: 'menu.nhcx_authorization_request',
        resource: 'nhcx_authorization_request',
        icon: 'fa fa-plus-square',
        url: 'nhcx_authorization_request',
        auto_crud: true,
        breadcrumb: 'NHCX Authorization Request',
        showMenu: true
    },
    {
        name: 'menu.nhcx_eligibility_request',
        resource: 'nhcx_eligibility_request',
        icon: 'fa fa-plus-square',
        url: 'nhcx_eligibility_request',
        auto_crud: true,
        breadcrumb: 'NHCX Eligibility Request',
        showMenu: true
    },
    {
        name: 'menu.view_claim_request',
        resource: 'view_claim_request',
        icon: 'fa fa-plus-square',
        url: 'view_claim_request',
        auto_crud: true,
        breadcrumb: 'View Claim Request',
        showMenu: true
    },
    {
        name: 'menu.view_e_order_claim_request',
        resource: 'view_e_order_claim_request',
        icon: 'fa fa-plus-square',
        url: 'view_e_order_claim_request',
        auto_crud: true,
        breadcrumb: 'View E-Order Claim Request',
        showMenu: true
    },
    {
        name: 'menu.nhcx_eligibile_preauth_request',
        resource: 'nhcx_eligibile_preauth_request',
        icon: 'fa fa-plus-square',
        url: 'nhcx_eligibile_preauth_request',
        auto_crud: true,
        breadcrumb: 'View Claim Request',
        showMenu: true
    },
    {
        name: 'menu.e_order_auth',
        resource: 'e_order_auth',
        icon: 'fa fa-plus-square',
        url: 'e_order_auth',
        auto_crud: true,
        breadcrumb: 'View Claim Request',
        showMenu: true
    },
    {
        name: 'menu.nhcx_claim_request',
        resource: 'nhcx_claim_request',
        icon: 'fa fa-plus-square',
        url: 'nhcx_claim_request',
        auto_crud: true,
        breadcrumb: 'Claim Request',
        showMenu: true
    },
    {
        name: 'menu.view_downloaded_e_order',
        resource: 'view_downloaded_e_order',
        icon: 'fa fa-plus-square',
        url: 'view_downloaded_e_order',
        auto_crud: true,
        breadcrumb: 'Claim Request',
        showMenu: true
    },
    {
        name: 'menu.nhcx_authorization_query',
        resource: 'nhcx_authorization_query',
        icon: 'fa fa-plus-square',
        url: 'nhcx_authorization_query',
        auto_crud: true,
        breadcrumb: 'NHCX Authorization Query',
        showMenu: true
    },
    {
        name: 'menu.nhcx_claim_resubmission',
        resource: 'nhcx_claim_resubmission',
        icon: 'fa fa-plus-square',
        url: 'nhcx_claim_resubmission',
        auto_crud: true,
        breadcrumb: 'NHCX Authorization Query',
        showMenu: true
    },
    {
        name: 'menu.nhcx_claim_query',
        resource: 'nhcx_claim_query',
        icon: 'fa fa-plus-square',
        url: 'nhcx_claim_query',
        auto_crud: true,
        breadcrumb: 'NHCX Authorization Query',
        showMenu: true
    },
    {
        name: 'menu.nhcx_eligibility_validation',
        resource: 'nhcx_eligibility_validation',
        icon: 'fa fa-plus-square',
        url: 'nhcx_eligibility_validation',
        auto_crud: true,
        breadcrumb: 'NHCX Authorization Query',
        showMenu: true
    }
]